import { Injectable } from '@angular/core';
import { WarehouseInventoryService } from '@ups/xplat/api/services';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchMaterialsService {
  constructor(public warehouseInventoryService: WarehouseInventoryService) {}

  search(searchString: string) {
    return this.warehouseInventoryService.materials$.pipe(
      map((materials) => {
        const searchMaterials = materials
          .filter((material) => material.name !== '')
          .filter((material) => {
            return (
              material['name']
                ?.toString()
                .toLowerCase()
                .indexOf(searchString.toLowerCase()) > -1 ||
              material['description']
                ?.toString()
                .toLowerCase()
                .indexOf(searchString.toLowerCase()) > -1 ||
              material['keyID']?.toString() === searchString
            );
          })
          .filter((material, index) => index < 50);

        return searchMaterials;
      })
    );
  }

  searchBarcode(searchString: string) {
    return this.warehouseInventoryService.materials$.pipe(
      map((materials) => {
        const searchMaterials = materials
          .filter((material) => material.name !== '')
          .filter((material) => {
            return material['keyID']?.toString() === searchString;
          })
          .filter((material, index) => index < 50);

        return searchMaterials;
      })
    );
  }
}
